import { render, staticRenderFns } from "./modal-company-details.html?vue&type=template&id=70a055f9&scoped=true&"
import script from "./modal-company-details.js?vue&type=script&lang=js&"
export * from "./modal-company-details.js?vue&type=script&lang=js&"
import style0 from "./modal-company-details.scss?vue&type=style&index=0&id=70a055f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a055f9",
  null
  
)

export default component.exports